"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var ContentContext_1 = __importDefault(require("../../context/ContentContext"));
var ApplyToolTip = function (_a) {
    var classBox = _a.classBox;
    var _b = (0, react_1.useState)(false), tooltipOpen = _b[0], setTooltipOpen = _b[1];
    var vacanciesDetailsTooltip = (0, react_1.useContext)(ContentContext_1.default).vacanciesDetailsTooltip;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ open: tooltipOpen, onMouseOver: function () {
            if (!isSmallScreen) {
                setTooltipOpen(true);
            }
        }, onMouseLeave: function () { return setTooltipOpen(false); }, arrow: true, placement: isSmallScreen ? 'top' : 'right', componentsProps: {
            tooltip: {
                sx: {
                    border: '1px solid',
                    borderColor: 'primary.main',
                    color: '#000',
                    backgroundColor: '#fff',
                },
            },
            arrow: {
                sx: {
                    color: 'primary.main',
                },
            },
        }, title: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                '& h6': { margin: 0, fontWeight: 'bold', fontSize: '1.25rem', lineHeight: '1.6', color: 'primary.main' },
                '& p': { margin: 0, fontWeight: 400, fontSize: '1rem', lineHeight: '1.5' },
            } }, { children: [(0, html_react_parser_1.default)("".concat(vacanciesDetailsTooltip)), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: {
                        position: 'absolute',
                        height: 36,
                        width: 36,
                        right: 10,
                        top: 8,
                    }, color: "primary", onClick: function () {
                        setTooltipOpen(false);
                    } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })) }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classBox, onClick: function () {
                if (isSmallScreen) {
                    setTooltipOpen(function (prevValue) { return !prevValue; });
                }
            } }, { children: (0, jsx_runtime_1.jsx)("img", { style: {}, src: "/img/tips.svg" }) })) })));
};
exports.default = ApplyToolTip;
